import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
window.fbq('init', '2169652790443333');
window.fbq('track', 'PageView');
// <noscript><img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=2169652790443333&ev=PageView&noscript=1" /></noscript>
createRoot(document.getElementById('root')!).render(<App data-id="element-87" />);